import z from "zod";

export const truncateMiddleDataSchema = z.object({
  text: z.string(),
  minChars: z.number().int().positive().optional(),
});

export type TruncateMiddleDataProps = z.infer<typeof truncateMiddleDataSchema>;
